import { CorrectiveSelectedImageBarType } from '@/modules/adjusterReportModules/IncidentParticipants/components/images/property/components/correctiveImages/correctiveSelectedImageBar/CorrectiveSelectedImageBar.type';
import { UseCorrectiveImagesType } from '@/modules/adjusterReportModules/IncidentParticipants/store/correctiveImages/useCorrectiveImages.type';
import { DamagedVehicleCorrectiveImageNameType } from '@/modules/adjusterReportModules/IncidentParticipants/types/images';
import { create } from 'zustand';

export const useCorrectiveImages = create<UseCorrectiveImagesType>()((set) => ({
  preFetchedCorrectiveImages: [],
  setPreFetchedCorrectiveImages: (item) => {
    const damageds: CorrectiveSelectedImageBarType[] =
      item?.damaged?.map((item) => ({
        id: item?.id,
        title: `${item?.title.fa_const} - ${item?.side_name.fa_const}`,
        type: DamagedVehicleCorrectiveImageNameType.damaged_parts,
        editable: false,
      })) ?? [];

    const documents: CorrectiveSelectedImageBarType[] =
      item?.documents?.map((item) => ({
        id: item?.id,
        title: item?.title.fa_const,
        type: DamagedVehicleCorrectiveImageNameType.documents,
        editable: false,
      })) ?? [];

    const vehicles: CorrectiveSelectedImageBarType[] =
      item?.vehicle?.map((item) => ({
        id: item?.id,
        title: item?.title.fa_const,
        type: DamagedVehicleCorrectiveImageNameType.vehicle,
        editable: false,
      })) ?? [];
    set((state) => ({
      ...state,
      preFetchedCorrectiveImages: [...damageds, ...documents, ...vehicles],
    }));
  },
  selectedDamagedParts: [],
  setSelectedDamagedParts: (item) =>
    set((state) => ({
      ...state,
      selectedDamagedParts: [...item],
    })),
  removeSelectedDamagedParts: (item) => {
    set((state) => ({
      ...state,
      selectedDamagedParts: state.selectedDamagedParts.filter(
        (selectedDamagedPart) => selectedDamagedPart.name !== item,
      ),
    }));
  },

  selectedDocuments: [],
  setSelectedDocuments: (item) =>
    set((state) => ({
      ...state,
      selectedDocuments: [...item],
    })),
  removeSelectedDocuments: (item) =>
    set((state) => ({
      ...state,
      selectedDocuments: state.selectedDocuments.filter(
        (selectedDocument) => selectedDocument.name !== item,
      ),
    })),
  selectedVehicle: [],
  setSelectedVehicle: (item) =>
    set((state) => ({
      ...state,
      selectedVehicle: [...item],
    })),
  removeSelectedVehicle: (item) =>
    set((state) => ({
      ...state,
      selectedVehicle: state.selectedVehicle.filter(
        (selectedVehicle) => selectedVehicle.name !== item,
      ),
    })),
  reset() {
    set({
      selectedDamagedParts: [],
      selectedDocuments: [],
      selectedVehicle: [],
    });
  },
}));
